import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';

/**
 * Página de callback SSO — recibe el JWT del portal via ?token=<jwt>
 * y autentica al usuario directamente sin pasar por el login.
 *
 * Ruta: /sso
 * Quién llega aquí: admins y moderadores que vienen de portal.aldealix.org
 */
export default function SsoCallback() {
  const [searchParams] = useSearchParams();
  const { login }       = useAuth();
  const navigate        = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setError('Token de acceso no encontrado. Vuelve al portal e inténtalo de nuevo.');
      return;
    }

    // Limpiar el token de la URL para no exponerlo en el historial
    window.history.replaceState(null, '', window.location.pathname);

    // Verificar el token con el backend
    api.me(token)
      .then(data => {
        const user = data.user;
        // Roles del personal con acceso vía SSO
        if (!['admin', 'moderator', 'incidencias'].includes(user.role)) {
          setError('No tienes permiso para acceder a esta sección.');
          return;
        }
        login(token, user);
        // Redirigir según rol
        const destino = user.role === 'admin' ? '/admin'
          : user.role === 'incidencias' ? '/admin/incidencias'
          : '/moderador';
        navigate(destino, { replace: true });
      })
      .catch(() => {
        setError('El enlace de acceso ha expirado o no es válido. Vuelve al portal.');
      });
  }, []); // eslint-disable-line

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      fontFamily: 'sans-serif',
      background: '#f8f7f4',
    }}>
      {error ? (
        <>
          <p style={{ color: '#c0392b', maxWidth: 360, textAlign: 'center' }}>{error}</p>
          <a
            href="https://portal.aldealix.org"
            style={{ color: '#5a6b5a', fontSize: 14, textDecoration: 'underline' }}
          >
            Volver al portal
          </a>
        </>
      ) : (
        <>
          <div style={{
            width: 32,
            height: 32,
            border: '3px solid #c8dfc8',
            borderTopColor: '#4a7c59',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }} />
          <p style={{ color: '#5a6b5a', fontSize: 14 }}>Iniciando sesión…</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </>
      )}
    </div>
  );
}
